import React, {useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {api} from "../../../../../../../services/Api/api";
import {useSessionService} from "../../../../../../../services/Session/sessionService";
import {useGeolocation} from "../../../../../../../hooks/useGeolocation";
import {ReactComponent as LocationIco} from "../../../../../../../../images/icons/location.svg";
import {ConfigApi, StoreConfigCoordinatesApi} from "../../../../../../../services/Api/types";
import {RootState} from "../../../../../../../../reducers";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import ChangeLocationMultistoreModal
    from "../../../../HomePage/components/HomeWithMap/Old/ChangeLocationMultistoreModal";
import {ReactComponent as AlertIco} from "../../../../../../../../images/icons/alert-error.svg";

interface OwnProps {
    setForcedCoordinatesToZoom: React.Dispatch<React.SetStateAction<StoreConfigCoordinatesApi | undefined>>;
    config: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPageGeolocationButton = ({session, setForcedCoordinatesToZoom, config}: Props) => {
    const {t} = useTranslation();
    const [loadingGeolocation, setLoadingGeolocation] = useState(false);
    const sessionService = useSessionService();
    const {getPosition, handleGeolocationError} = useGeolocation();
    const [showAddressModal, setShowAddressModal] = useState(false);

    const handleGeolocation = async () => {
        try {
            setLoadingGeolocation(true);
            const position = await getPosition();
            const {latitude, longitude} = position.coords;
            const res = await api.getAddressByCoordinates({latitude, longitude});
            await sessionService.update({
                ...session,
                address: {
                    street: res.street ?? "",
                    city: res.city ?? "",
                    country: res.country ?? "",
                    zip_code: res.zip_code ?? "",
                    flat_nr: res.flat_nr ?? "",
                    build_nr: res.build_nr ?? "",
                }
            });
            await sessionService.updateCoordinates({
                latitude,
                longitude
            });
            setForcedCoordinatesToZoom({
                latitude,
                longitude
            });
        } catch (error) {
            handleGeolocationError(error as GeolocationPositionError);
            setShowAddressModal(true);
        } finally {
            setLoadingGeolocation(false);
        }
    }

	return (
        <>
            <button className={`btn btn-default btn-icon btn-lg btn-spinner ${loadingGeolocation ? "loading" : ""}`}
                    onClick={handleGeolocation}
                    aria-label={t("modules.multistore.field.geolocation.title")}>
                {!loadingGeolocation && <LocationIco aria-hidden="true"/>}
                <span className="left spinner-border spinner-border-sm"/>
            </button>
            {
                showAddressModal &&
                <ChangeLocationMultistoreModal showModal={showAddressModal}
                                               onHide={() =>  setShowAddressModal(false)}
                                               config={config} withoutGeolocation
                                               onChange={() =>  setShowAddressModal(false)}
                                               icon={<AlertIco/>}
                                               description={t("modules.multistore.field.your_address_was_not_found.description")}
                                               title={t("modules.multistore.field.your_address_was_not_found.title")}
                                               iconClassName="text-danger"
                />
            }
        </>
	)
};

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPageGeolocationButton));
